'use client';

import { signIn } from 'src/app/api/auth/auth-client';
import { useSession } from 'src/services/state/providers/SessionProvider';

import { useRouter } from 'next/navigation';
import type { MouseEvent } from 'react';

export function useSignInOnClick(): (event?: MouseEvent<HTMLElement>) => void {
  const session = useSession();
  const router = useRouter();

  return (event) => {
    event?.preventDefault();

    if (session) {
      router.push('/home');
      return;
    }

    void signIn.social({
      provider: 'mymass',
      callbackURL: `${process.env.NEXT_PUBLIC_BASE_PATH}/home`,
    });
  };
}
